<template>
  <helper-layout :loaded="mx_loaded">
    <material-table :headers="headers" :paginate="paginateConfig" :total-count="paymentMethods.totalCount" :items="paymentMethods.items" @pageChange="handlePageChange">
      <!-- 表格顶部工具栏 -->
      <template v-slot:toolbar>
        <v-layout justify-end class="toolbar">
          <v-flex shrink>
            <v-btn v-if="getPermission('SystemSettings.PaymentMethod.CreateOrEdit')" solid color="success" @click="handleEditMethods('create')">
              <!-- 新增 -->
              {{ $t('Views.Setting.create') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
    </material-table>

    <!-- 弹窗 -->
    <material-dialog :visible="showDialog" :title="getDialogTitle" width="600" @cancleFn="handleCloseDialog" @confirmFn="handleSubmitDialog">
      <template>
        <div>
          <v-form ref="form" v-model="valid" xs12 @submit.native.prevent>
            <!-- 支付方法名 -->
            <v-layout class="is-required">
              <v-text-field v-model="form.name" :counter="32" :maxlength="32" required clearable :rules="rules.name" :label="$t('Views.Setting.paymentName')" placeholder="" />
            </v-layout>
            <!-- 设为默认 -->
            <v-layout class="default-radio">
              <span>{{ $t('Views.Setting.isVisible') }}</span>
              <v-checkbox v-model="form.enable" :color="color" />
            </v-layout>
          </v-form>
        </div>
      </template>
    </material-dialog>
  </helper-layout>
</template>

<script>
import { pageLoadMx } from '@/plugins/mixins'
import { mapActions, mapState } from 'vuex'

export default {
  mixins: [pageLoadMx],
  data() {
    const $t = this.$t.bind(this)
    return {
      valid: true,
      headers: [
        {
          text: $t('Views.Setting.index'),
          value: 'index',
          isSort: true
        },
        {
          text: $t('Views.Setting.paymentName'),
          value: 'name'
        },
        {
          text: $t('Views.Setting.isVisible'),
          value: 'enable',
          render: (h, param) => {
            return h('div', param.row.enable ? $t('Views.Setting.mailVisibleText') : $t('Views.Setting.banned'))
          }
        },
        {
          text: $t('Views.Setting.action'),
          value: 'action',
          actions: [
            {
              text: $t('Views.Setting.edit'),
              color: this.$store.state.app.editBtnColor,
              visible: row => {
                return this.getPermission('SystemSettings.PaymentMethod.CreateOrEdit')
              },
              actionFn: row => {
                this.handleEditMethods('edit', row.row)
              }
            }
          ]
        }
      ],
      showDialog: false,
      editType: '',
      form: {
        name: '',
        enable: true,
        id: '',
        skipCount: 0,
        maxResultCount: 10
      },
      rules: {
        name: [this.$util.rules.emptyRule($t('Views.Setting.paymentName'))]
      },
      paginateConfig: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    ...mapState('setting', ['paymentMethods']),
    color() {
      return this.$store.state.app.color
    },
    getDialogTitle() {
      let title = ''
      switch (this.editType) {
        case 'edit':
          title = this.$t('Views.Setting.edit_payment')
          break
        case 'create':
          title = this.$t('Views.Setting.new_payment')
          break
        default:
          break
      }
      return title
    }
  },
  mounted() {
    this.getPage()
  },
  methods: {
    ...mapActions('setting', ['getPaymentMethods', 'editPaymentMethod']),
    getPage(page) {
      if (typeof page !== 'undefined') {
        this.paginateConfig.page = page
        this.form.skipCount = (page - 1) * this.form.maxResultCount
      }
      if (!this.mx_loaded) this.mx_loading_fn() // 页面加载中
      this.getPaymentMethods(this.form).then(() => {
        this.paginateConfig.total = this.paymentMethods.totalCount
        this.mx_loaded_fn() // 页面加载完成
      })
    },
    handleEditMethods(type, item) {
      this.editType = type
      if (item) {
        this.form = Object.assign({}, this.form, item)
      }
      this.showDialog = true
    },
    handleSubmitDialog() {
      if (this.$refs.form.validate()) {
        this.editPaymentMethod({ ...this.form }).then(() => {
          this.showDialog = false
          this.resetForm()
          this.getPage()
        })
      }
    },
    handleCloseDialog() {
      this.showDialog = false
      this.resetForm()
    },
    getPermission(name) {
      return this.$util.tool.hasPerm(name)
    },
    resetForm() {
      this.$refs.form.resetValidation()
      this.form.name = ''
      this.form.enable = true
      this.id = ''
    },
    handlePageChange(page) {
      this.getPage(page)
    }
  }
}
</script>

<style>
.is-required {
  position: relative;
}
.is-required:before {
  content: '*';
  position: absolute;
  color: #f00;
  left: -10px;
  top: 1px;
  font-size: 18px;
}
.default-radio {
  margin-top: 10px;
  height: 24px;
}
.default-radio span {
  font-size: 14px;
  font-weight: bold;
  color: #515151;
}
.default-radio .v-input--selection-controls {
  margin-top: -3px;
  margin-left: 10px;
  padding-top: 0;
}
</style>
